import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  bgColor: "#3f8cf2",
  boardColor: "#dadfe9",
  cardColor: `#ffffff`,
};
